// extracted by mini-css-extract-plugin
export default {"LanguageBox":"Language_LanguageBox__-hq8H","img":"Language_img__oM5r0","img_active":"Language_img_active__bSv6L"};